// extracted by mini-css-extract-plugin
export var externalLink = "_a1-0";
export var internalLinkLabel = "_a1-1";